<div class="navigation-pager">
  <ng-container *ngIf="showItemsInfo">
    <span class="showing-label" i18n="@@showing">Showing: </span>
    <span><b>{{ totalItems > itemsPerPage ? itemsPerPage : totalItems }}</b>&nbsp;<span i18n="@@of">of</span>&nbsp;<b>{{ totalItems }}</b></span>
  </ng-container>
  <dx-button
    icon="chevronleft"
    stylingMode="text"
    (onClick)="goToPreviousPage()"
    [disabled]="currentPage <= 1"
  ></dx-button>
  <ng-container *ngFor="let page of getPaginationPages()">
    <span *ngIf="page === '...'" class="separator">...</span>
    <dx-button
      *ngIf="page !== '...'"
      [text]="page"
      stylingMode="text"
      (onClick)="goToPage(page)"
      [class.active-page]="page === currentPage"
      class="page-button"
    ></dx-button>
  </ng-container>
  <dx-button
    icon="chevronright"
    stylingMode="text"
    (onClick)="goToNextPage()"
    [disabled]="currentPage >= totalPages"
  ></dx-button>
</div>
